// @ts-nocheck
import React from 'react';
// import AddAbsence from '../../HR/Employees/Absence/AddAbsence';
import AddAbsence from '../../HR/Employees/AbsencesAndVacations/Absence/AddAbsence';
import WorkRequestForm from '../../FLEET/WorkRequests/WorkRequestForm';
import AddApExpense from '../../Finance/Ap/ApExpense/AddAme';
import AddPurchaseOrder from '../../PUR/Transactions/PurchaseOrder/AddPoAme';
import AddPurchaseRequest from '../../PUR/Transactions/PurchaseRequest/AddAme';
import AddAttendanceAdjustment from '../../HR/Raqeeb/AttendanceAdjustment/AddAttendanceAdjustment';
import FormAddEquipments from '../../FLEET/Equipments/FormAddEquipments';

const StaticForm = ({ StaticFormId, setReferenceId }) => {
  let Component = null;
  // console.log(StaticFormId);

  switch (StaticFormId) {
    case '19b2d5d2-8864-4e5d-b07e-4c1713d07a3c': // Absence Form ID from Seeding
      Component = <AddAbsence isAme={true} setReferenceId={setReferenceId} />;
      break;
    case '664a4b6f-5849-4654-923e-854ea748ad50': // Absence Form ID from Seeding
      Component = <AddAttendanceAdjustment isAme={true} setReferenceId={setReferenceId} />;
      break;
    case 'd9e918b3-b706-4281-a6e6-5101be1bcd63': // WorkRequest Form ID from Seeding
    // case 'e2f51e18-fa6e-45ba-9f10-36b1ca96c987': // WorkRequest Form ID from Seeding
      Component = <WorkRequestForm isAme={true} setReferenceId={setReferenceId} />;
      break;
    case '34347b6e-32ca-4ffb-aa27-82498da81411': //
      Component = <AddApExpense />;
      break;
    case '733ad7ac-b2ff-4b2a-814a-78c71153447f': //
      Component = <AddPurchaseOrder />;
      break;
    case '62d18267-8f18-4907-b38a-494aa53de0af': //
      Component = <AddPurchaseRequest />;
      break;
    case 'af7c1cca-8dd2-4707-992f-4c9e1cc55558': // "طلب إضـافة مركبة جديـدة "
      Component = <FormAddEquipments isAme={true} setReferenceId={setReferenceId} />;
      // Component = <FormAddEquipments />;
      break;
    default:
      <div> .. Neatix ERP .. </div>;
  }

  return <div>{Component}</div>;
};

export default StaticForm;
